export default {
  TOKEN: null, // sid
  LOGINKOKEN: '04b650ea-dc85-4110-9c54-f46499f213da', // 登录ToKen
  LOGINUSER: null, //登录用户
  userList:[],    // 客户列表
  simList:[],
  totalNum:0,
  passwordFlag:'',//支付密码状态
  totalCorn:{}
}
